import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthSessionResponse, User, UserOrganization } from '../models/user.model';
import { API_BASE_URL } from '../constants/api.constants';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly http = inject(HttpClient);
  private readonly apiBaseUrl = inject(API_BASE_URL);

  startLogin(): void {
    window.location.assign(`${this.apiBaseUrl}/auth/login`);
  }

  mockLogin(email: string, password: string): Observable<AuthSessionResponse> {
    return this.http.post<AuthSessionResponse>(`${this.apiBaseUrl}/auth/login`, {
      email,
      password,
    });
  }

  getUser(userId: number): Observable<User> {
    return this.http.get<User>(`${this.apiBaseUrl}/user/${userId}`);
  }

  getCurrentSession(): Observable<AuthSessionResponse> {
    return this.http.get<AuthSessionResponse>(`${this.apiBaseUrl}/auth/me`);
  }

  getUserOrganizations(userId: number): Observable<UserOrganization[]> {
    return this.http.get<UserOrganization[]>(`${this.apiBaseUrl}/user-organization`, {
      params: { userId },
    });
  }

  logout(): Observable<void> {
    return this.http.post<void>(`${this.apiBaseUrl}/auth/logout`, {});
  }

  changePassword(currentPassword: string, newPassword: string): Observable<void> {
    return this.http.post<void>(`${this.apiBaseUrl}/auth/change-password`, {
      currentPassword,
      newPassword,
    });
  }
}
